import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: "1.1rem"
      },
      helpText: {
          fontWeight: "bold",
          padding: "30px 20px 0 20px",
          fontSize: "1.2rem"

      }
}));

export default function ActivityDescDelta() {
    const classes = useStyles();  

  
    return (
        <div>
             <div className={classes.root}>
                Review the <span style={{fontWeight: "bold"}}>stressful bullets on page 4 of your report.</span><br/>
                Pick the 3 that you would want others to know.<br/>
                Record those here.<br/>
                &nbsp;
            </div>
            <div className={classes.helpText}>
                To begin adding an entry, tap on the pencil icon in the Stressors column.
            </div>
        </div>
       
    )
}
